import { colors } from "../../styles/design-tokens";
export const CrossSVGIcon = ({ fill = colors.neutral.darkest as string, height = "24" }: { fill?: string; height?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={height}
    viewBox="0 -960 960 960"
    style={{ fill }}
  >
    <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
  </svg>
);